import e from"styled-components";const i=e.div`
	display: flex;
	height: 100%;
	gap: ${({isTemplate:e})=>e?"4px":"8px"};
`,t=e.div`
	background-image: ${({backgroundURL:e})=>`url(${e})`};
	background-size: cover;
	height: 100%;
	aspect-ratio: 1 / 1;
	background-position: center;
	border-radius: ${({borderRadius:e})=>"number"==typeof e?e:14}px;
`;e.img`
	width: ${({isTemplate:e})=>e?"9.5px":"20px"};
	height: ${({isTemplate:e})=>e?"9.5px":"20px"};
	border-radius: 50px;
	object-fit: cover;
`,e.div`
	display: flex;
	flex-direction: column;
	gap: 8px;
`;const o=e.div`
	padding: ${({zeroPadding:e})=>e?"0":"8px 12px"};
	box-sizing: border-box;
	height: 100%;
	flex: 1;

	display: flex;
	flex-direction: column;
	justify-content: space-between;
	position: relative;
	overflow: hidden;
`,p=e.div`
	display: flex;
	flex-flow: row;
	align-items: center;
	gap: ${({isTemplate:e})=>e?"4px":"8px"};
`,l=e.div`
	display: flex;
	flex-flow: column;
	gap: 8px;
`,n=e.div`
	color: #999;
	font-family: 'SF Pro Display';
	font-size: ${({isTemplate:e})=>e?"7px":"13px"};
	font-style: normal;
	font-weight: 500;
	line-height: 20px;

	white-space: nowrap;
	overflow: hidden;
	text-overflow: ellipsis;
`,a=e.div`
	background: #999;
	width: ${({isTemplate:e})=>e?"1.8px":"4px"};
	min-width: ${({isTemplate:e})=>e?"1.8px":"4px"};
	height: ${({isTemplate:e})=>e?"1.8px":"4px"};
	border-radius: 50%;
`,r=e.div`
	color: ${({theme:e})=>e.text.title};
	font-family: 'SF Pro Display';
	font-size: ${({isTemplate:e})=>e?"8.6px":"18px"};
	font-style: normal;
	font-weight: 500;
	line-height: ${({isTemplate:e})=>e?"9.691px":"21px"};
	display: -webkit-box;
	-webkit-line-clamp: 2;
	-webkit-box-orient: vertical;
	overflow: hidden;
	text-overflow: ellipsis;
`;e.div`
	color: #999;
	font-family: 'SF Pro Display';
	font-size: 14px;
	font-style: normal;
	font-weight: 400;
	line-height: 130%;
`;const s=e.div`
	display: flex;
	flex-flow: row;
	align-items: center;
	gap: 4px;
	max-width: 0;

	&::after {
		content: '';
		position: absolute;
		right: 0;
		bottom: 0;
		width: 40px;
		height: 30px;
		pointer-events: none;
		background: ${({theme:e})=>`linear-gradient(90deg, transparent 0%, ${e.bg.card} 100%);`};
	}
`,x=e.div`
	display: flex;
	padding: ${({isTemplate:e})=>e?"2.154px 4.307px":"2px 6px"};
	justify-content: center;
	align-items: center;
	gap: 10px;
	border-radius: 100px;
	background: ${({colors:e,theme:i})=>e.accent[i.name].slice(0,7)+"4D"};
	color: ${({colors:e,theme:i})=>e.accent[i.name]};
	font-family: 'SF Pro Display';
	font-size: ${({isTemplate:e})=>e?"7px":"13px"};
	font-style: normal;
	font-weight: 500;
	line-height: ${({isTemplate:e})=>e?"7px":"16px"};
	white-space: nowrap;
`,d=e.div`
	display: flex;
	padding: ${({isTemplate:e})=>e?"2.154px 4.307px":"2px 6px"};
	justify-content: center;
	align-items: center;
	gap: 10px;
	border-radius: 100px;
	background: ${({colors:e,theme:i})=>null==e?void 0:e.accent[i.name]};
	color: ${({colors:e,theme:i})=>null==e?void 0:e.text[i.name]};
	font-family: 'SF Pro Display';
	font-size: ${({isTemplate:e})=>e?"7px":"13px"};
	font-style: normal;
	font-weight: 500;
	line-height: ${({isTemplate:e})=>e?"7px":"16px"};
	white-space: nowrap;
`;export{n as Author,p as AuthorWrapper,a as Divider,t as ImageContainer,x as Label,i as ListContent,o as RightContent,d as Space,s as TagWrapper,r as Title,l as TitleAndAuthor};
